import styled from "styled-components"

export const InputLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.6);
`
